module.exports = __webpack_public_path__ + "static/media/hotel-6.9e12e268.jpg";